import { Carousel } from '@mantine/carousel';
import { createTheme } from '@mantine/core';

export const mantineTheme = createTheme({
  components: {
    Carousel: Carousel.extend({
      styles: {
        control: { backgroundColor: '#846701', height: 15, color: 'white' },
        indicator: { backgroundColor: '#846701', height: 15 },
        controls: { position: 'absolute', bottom: 10, display: 'flex', alignItems: 'end' },
        root: { border: '1px solid #ccc', borderRadius: 8, padding: '10px 10px 40px 10px' },
        slide: { display: 'flex', flexDirection: 'column', gap: 10 },
      },
    }),
  },
});
